<template>
  <div class="main">
    <c-panel>
      <form-consumo :paramId="$route.params.id" v-on:onSubmitConsumo="onSubmitConsumo"></form-consumo>
    </c-panel>
  </div>
</template>
<script>
import formConsumo from "./form"

export default {
  methods: {
    onSubmitConsumo () {
      this.$router.push('/admin/merenda/consumo')
    }
  },
  components: { formConsumo }
}
</script>

